import { z } from "zod";
import { vinSchema } from "@qivia/schemas-shared";
import { dataPointsForwardDestinationSchema } from "../_shared";

export const startDataPointsForwardPayloadSchema = z.object({
  vin: vinSchema,
  destination: dataPointsForwardDestinationSchema,
  startAt: z.iso.datetime(),
});

export type StartDataPointsForwardPayload = z.infer<
  typeof startDataPointsForwardPayloadSchema
>;
